export default __webpack_public_path__ + "static/media/Santosh Rao.8c0cbb91.jpg";